import { onReady } from './utils/on-ready';
import { getUrlParameter } from './utils/url-helper';

export class HomeownersQuiz {
    constructor() {
        onReady(() => {
            if (document.getElementsByClassName('homeowners-quiz').length) {
                this.setQuiz();
            }
        });
    }

    showProgess = () => {
        const sectionCount = $(document).find("div[name='progressIndicator']");

        //get current Section
        if (sectionCount) {
            const offset = (1 - this.calculateProgress(sectionCount)) * 100;

            $('#homeownersQuizProgress').find('.ifbi-progress-bar__inner').css('transform', `translateX(-${offset}%)`);
        }
    }

    calculateProgress = (sections) => {
        const sectionVisible = $("div[name='progressIndicator']:visible");
        let index;

        for (var i = 0; i < sections.length; i++) {
            if (sectionVisible.length > 0 && (sections[i].id === sectionVisible[0].id)) {
                index = i;
            }
        }

        return index / (sections.length - 1);
    }

    setExplanations = (selectedAnswer) => {
        switch (selectedAnswer.id) {
            case 'question1Answer':
                $('#question1Explain').show();
                break;
            case 'question5Answer':
                $('#question5Explain').show();
                break;
            case 'question6Answer':
                $('#question6Explain').show();
                break;
        }
    }

    updateQuizStyle = (event) => {
        const selectedAnswer = this.setRadioButtons(event);

        if (selectedAnswer.classList.contains('correct-answer')) {
            selectedAnswer.classList.add('active-correct-answer');

            this.setExplanations(selectedAnswer);

            $("span[name='correctAnswer']").show();
            $("span[name='wrongAnswerMessage']").hide();
            $('#next-question').prop('disabled', false);
        }
        else {
            selectedAnswer.classList.add('active-incorrect-answer');
            $("span[name='wrongAnswerMessage']").show();
            $('#next-question').prop('disabled', true);

            //Ensure that only the error icon for the selected answer shows up since they all share the same name.
            $.each(selectedAnswer.children, function (index, val) {
                if (val.className == 'material-icons error-icon')
                    val.attributes.style.value = 'inline-block';
            })
        }
    }

    setRadioButtons = (event) => {
        const selectedAnswer = event.currentTarget != null && event.currentTarget != "" ? event.currentTarget : event;

        //Get the id of the radio button in the currently selected element and set input to checked..
        //This allows the radio button itself or its containing element to be selected and still check the button.
        $.each(selectedAnswer.children, function (index, val) {
            if (val.className == 'mdc-radio mdc-radio--touch')
                $.each(val.children, function (index, val) {
                    if (val.className == 'mdc-radio__native-control') {
                        const currentRadioInput = (<HTMLInputElement>document.getElementById(val.id));

                        currentRadioInput.checked = true;
                    }
                });
        });

        return selectedAnswer;
    }

    clearAnswers = () => {
        //Clear all elements of active classes so we don't apply style to multiple answers.
        $('.correct-answer').removeClass('active-correct-answer');
        $('.incorrect-answer').removeClass('active-incorrect-answer');
        $("span[name='correctAnswer']").hide();
        $("span[name='answerError']").hide();
    }

    setQuiz = () => {
        $("span[name='correctAnswer']").hide();
        $("span[name='answerError']").hide();

        const quiz = this; // jquery overrides "this" inside event bindings, need a way to reference it

        $('.homeowners-quiz').on('click', '#begin-quiz', function () {
            $('#start-quiz').hide();
            $('#homeowners-quiz').show();

            quiz.showProgess();
        });

        $('.homeowners-quiz').on('click', "div[name='answer']", function (event) {
            quiz.clearAnswers();
            quiz.updateQuizStyle(event);
        });

        $('.homeowners-quiz').on('click', '#next-question', function () {
            quiz.clearAnswers();
            quiz.updateQuizSections(true);
            quiz.showProgess();
        });

        $('.homeowners-quiz').on('click', '#previous-question', function () {
            quiz.clearAnswers();
            quiz.updateQuizSections(false);
            quiz.showProgess();
        })

        $('.homeowners-quiz').on('click', '#quote-button', function () {
            let param = getUrlParameter('AC');
            let quoteUrl = (<HTMLInputElement>document.getElementById('quote-url'));

            if (param != null && param != "")
                location.href = quoteUrl.value + '?' + 'AC=' + param;
        })

        $('.homeowners-quiz').on('click', '#reach-agent-button', function () {
            let param = getUrlParameter('AC');
            let reachAgentUrl = (<HTMLInputElement>document.getElementById('reach-agent-url'));

            if (param != null && param != "")
                location.href = reachAgentUrl.value + '&' + 'AC=' + param;
        })
    }

    updateQuizSections = (isNext) => {
        let currentDiv = "";
        const q1 = $('#question1:visible'),
            q2 = $('#question2:visible'),
            q3 = $('#question3:visible'),
            q4 = $('#question4:visible'),
            q5 = $('#question5:visible'),
            q6 = $('#question6:visible'),
            q7 = $('#question7:visible'),
            q8 = $('#question8:visible'),
            q9 = $('#question9:visible');

        if (q1.length > 0)
            currentDiv = q1[0].id;
        else if (q2.length > 0)
            currentDiv = q2[0].id;
        else if (q3.length > 0)
            currentDiv = q3[0].id;
        else if (q4.length > 0)
            currentDiv = q4[0].id;
        else if (q5.length > 0)
            currentDiv = q5[0].id;
        else if (q6.length > 0)
            currentDiv = q6[0].id;
        else if (q7.length > 0)
            currentDiv = q7[0].id;
        else if (q8.length > 0)
            currentDiv = q8[0].id;
        else
            currentDiv = q9[0].id;

        switch (currentDiv) {
            case 'question1':
                if (isNext) {
                    $('#question1').hide();
                    $('#question2').show();
                    $('#previous-question').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    $('#homeowners-quiz').hide();
                    $('#start-quiz').show();
                    break;
                }
            case 'question2':
                if (isNext) {
                    $('#question2').hide();
                    $('#question3').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question1Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $('#question1Explain').show();
                    $("#next-question").prop('disabled', false);
                    $('#question2').hide();
                    $('#question1').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question3':
                if (isNext) {
                    $('#question3').hide();
                    $('#question4').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question2Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question3').hide();
                    $('#question2').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question4':
                if (isNext) {
                    $('#question4').hide();
                    $('#question5').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question3Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question4').hide()
                    $('#question3').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question5':
                if (isNext) {
                    $('#question5').hide();
                    $('#question6').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question4Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question5').hide();
                    $('#question4').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question6':
                if (isNext) {
                    $('#question6').hide();
                    $('#question7').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question5Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question5Explain').show();
                    $('#question6').hide();
                    $('#question5').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question7':
                if (isNext) {
                    $('#question7').hide();
                    $('#question8').show();
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question6Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question6Explain').show();
                    $('#question7').hide();
                    $('#question6').show();

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question8':
                if (isNext) {
                    $('#question8').hide();
                    $('#question9').show();
                    $('#next-question')[0].innerHTML = 'Finish';
                    $("#next-question").prop('disabled', true);
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question7Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question8').hide();
                    $('#question7').show()

                    this.setRadioButtons(correctAnswer);
                    break;
                }
            case 'question9':
                if (isNext) {
                    $('#question9').hide();
                    $('#homeowners-quiz').hide();
                    $('#homeowners-facts').show();
                    launchConfetti();
                    break;
                }
                else {
                    var correctAnswer = document.getElementById('question8Answer');

                    correctAnswer.classList.add('active-correct-answer');

                    $("#next-question").prop('disabled', false);
                    $('#question9').hide();
                    $('#question8').show();
                    $('#next-question')[0].innerHTML = 'Next';

                    this.setRadioButtons(correctAnswer);
                    break;
                }
        }
    }
}